import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row, } from "reactstrap";
import { Btn, H3, Image, P } from "../../AbstractElements";
import { Password } from "../../utils/Constant";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAppSelector } from "../../ReduxToolkit/Hooks";
import { submitFeedbackAction } from "../../Api/feedback";

const FeedbackContainer = () => {
  const [subject, setSubject] = useState("");
  const navigate = useNavigate();
  const [description, setDescription] = useState("")
  const user = useAppSelector(state => state.user)

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    try {
      const response = await submitFeedbackAction({ subject, description });
      if (response.status === 'success') {
        toast.success(response.message);
        navigate('/');
      } else {
        if (response.response)
          toast.error(response.response.data.message)
        else
          toast.error("Feedback submit error!")
      }
    } catch (error) {
      toast.error("Feedback submit failed!");
    }
  };


  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark" style={{ background: 'none', minHeight: 'calc(100vh - 80px)', paddingBottom: '120px' }}>
            <div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={handleSubmit}>
                  <H3>{"Feedback"}</H3>
                  <P>{"We appreciate your feedback. Help us how to improve Texlex."}</P>
                  <FormGroup>
                    <Label className="col-form-label">{"Subject"}</Label>
                    <div className="form-input position-relative">
                      <Input type={"text"} className="w-100 form-control" placeholder="Eg: Website error" required autoComplete='' onChange={(event) => setSubject(event.target.value)} />
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{"Description"}</Label>
                    <div className="form-input position-relative">
                      <Input type='textarea' className="w-100 form-control" placeholder="Eg: Website loading too slow.." required autoComplete='' onChange={(event) => setDescription(event.target.value)} style={{ height: '120px' }} />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-0 form-sub-title">
                    <div className="text-end mt-3">
                      <Btn color="primary" block className="w-100" type="submit">
                        {"Submit"}
                      </Btn>
                    </div>
                  </FormGroup>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
};

export default FeedbackContainer;
